import '../_root.js';
import '../_tracking.js';
import '../FetchIt.js';
import '../app_state.js';
import '../_util.js';
import '../_util.pwa.js';
import '../_util.log.js';
import '../_util.network.js';
import '../_util.validate.js';
import '../_util.timezone.js';

import '../_wdk/wdk_security.js';
import '../_wdk/wdk_brands.js';
import '../_wdk/wdk_screensize.js';
import '../_wdk/wdk_modalbox.js';
import '../_wdk/wdk_hintbox.js';
import '../_wdk/wdk_forms.js';
import '../_wdk/wdk_loading_indicator.js';
import '../_wdk/wdk_button.js';
import '../_wdk/wdk_password_restriction_box.js';
import '../login_and_registration/_dominit.js';
import '../login_and_registration/_util.js';
import '../login_and_registration/gender_select_page.js';
import '../login_and_registration/gender_select_page_deprecated.js';
import '../login_and_registration/login_page.js';
import '../login_and_registration/login_page.social_sign_on.js';
import '../login_and_registration/par_countdown.js';
import '../login_and_registration/password_page.js';
import '../login_and_registration/registration_page.js';
import '../login_and_registration/registration_page.social_sign_on.js';
import '../login_and_registration/registration_page.validate.js';
import '../login_and_registration/search_gender_select_page.js';
import '../login_and_registration/verification_page.js';

// WebComponents
// "App" Scope
import pegAppleSocialButton from '../peg-apple-social-button.js';
import pegGoogleSocialButton from '../peg-google-social-button.js';
import pegCookiebanner from '../peg-cookiebanner.js';
import pegOfflineNotification from '../peg-offline-notification.js';
import bstMessageKeys from '../bst-message-keys.js';
import pegFooter from '../peg-footer.js';
import pegOtpPage from '../login_and_registration/peg-otp-page.js';
import pegLivenessPage from '../login_and_registration/peg-liveness-page.js';
import pegLivenessPageDone from '../login_and_registration/peg-liveness-page-done.js';
import pegMandatoryPhotoUpload from '../login_and_registration/peg-mandatoryphotoupload-page.js';
import pegVerificationCode from '../login_and_registration/peg-verification-code.js';
import pegOtpHelpDialog from '../login_and_registration/peg-otp-help-dialog.js';
import pegTurnstile from '../login_and_registration/peg-turnstile.js';
import pegPhotoSelector from '../_shared_features/photo_tools/peg-photo-selector.js';
import pegPhotoUploader from '../_shared_features/photo_tools/peg-photo-uploader.js';
import pegPhotoEditor from '../_shared_features/photo_tools/peg-photo-editor.js';
import pegPhotoUploadDialog from '../_shared_features/photo_tools/peg-photo-upload-dialog.js';

// WDK
import wdkHintboxError from '../_wdk/wdk-hintbox-error.js';
import wdkInputCheckobx from '../_wdk/wdk-input-checkbox.js';
import wdkDialog from '../_wdk/wdk-dialog/wdk-dialog.js';
import pegErrorDialog500 from '../peg-error-dialog-500.js';
import wdkHintbox from '../_wdk/wdk-hintbox.js';

// *********** Usages ***********
// "App" Scope
customElements.define('peg-apple-social-button', pegAppleSocialButton);
customElements.define('peg-google-social-button', pegGoogleSocialButton);
customElements.define('peg-cookiebanner', pegCookiebanner);
customElements.define('bst-message-keys', bstMessageKeys);
customElements.define('peg-footer', pegFooter);
customElements.define('peg-offline-notification', pegOfflineNotification);
customElements.define('peg-otp-page', pegOtpPage);
customElements.define('peg-liveness-page', pegLivenessPage);
customElements.define('peg-liveness-page-done', pegLivenessPageDone);
customElements.define('peg-mandatoryphotoupload-page', pegMandatoryPhotoUpload);
customElements.define('peg-verification-code', pegVerificationCode);
customElements.define('peg-otp-help-dialog', pegOtpHelpDialog);
customElements.define('peg-error-dialog-500', pegErrorDialog500);
customElements.define('peg-turnstile', pegTurnstile);
customElements.define('peg-photo-selector', pegPhotoSelector);
customElements.define('peg-photo-uploader', pegPhotoUploader);
customElements.define('peg-photo-editor', pegPhotoEditor);
customElements.define('peg-photo-upload-dialog', pegPhotoUploadDialog);

// WDK
customElements.define('wdk-hintbox', wdkHintbox);
customElements.define('wdk-hintbox-error', wdkHintboxError);
customElements.define('wdk-input-checkbox', wdkInputCheckobx);
customElements.define('wdk-dialog', wdkDialog);
